module.exports = __webpack_public_path__ + "eaa7c112d7eba0beac7b06e9cd0e21e4.png";